import { render } from "./FramesByMarket.vue?vue&type=template&id=58091efc"
import script from "./FramesByMarket.vue?vue&type=script&lang=js"
export * from "./FramesByMarket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__